<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="orderNum">
        <el-input v-model="queryParams.orderNum" placeholder="订单号"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="profitType">
        <el-select v-model="queryParams.profitType"  filterable placeholder="分账类型" @change="search" clearable >
          <el-option  label="入账" value="1"></el-option>
          <el-option  label="分账" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border @selection-change="handleSelectionChange">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="orderNum" label="订单号" align="center" min-width="110" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- 核心：加外层容器，用flex布局分隔文字和图标 -->
            <div class="ip-cell-container">
              <!-- IP文字区域：单独做溢出隐藏 -->
              <span class="ip-text">{{ scope.row.orderNum }}</span>
              <!-- 复制图标：独立显示，不受文字隐藏影响 -->
              <el-tooltip 
                v-if="scope.row.ip" 
                class="item" 
                effect="dark" 
                :content="$t('app.common.copy')" 
                placement="top-start"
              >
                <i 
                  style="font-size:16px;margin-left:2px;cursor:pointer" 
                  class="el-icon-document-copy" 
                  @click="copy(scope.row.ip)" 
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="appId" label="APPID" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="mchId" label="商户号" width="100" align="center"></el-table-column>
        <el-table-column prop="profitType" label="分账类型" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.profitType=='1'" type="success">入账</el-tag>
                <el-tag v-if="scope.row.profitType=='2'" type="info">分账</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="outOrderNo" label="分账单号" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="orderMoney" label="订单金额" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="amount" label="分账金额" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="type" label="接收方类型" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="account" label="接收方账号" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="接收方姓名" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="description" label="分账描述" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="state" label="分账状态" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="result" label="分账结果" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="finishTime" label="完成时间" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="errCode" label="失败码" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="errDesc" label="失败原因" align="center" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { ProfitSharingOrderList } from "@/api/profitsharing.js";
export default {
  name: "orientation",
  data() {
    return{
      queryParams:{
        orderNum:undefined,
        profitType:undefined
      },
      tableData:[],
      dateRange:[],
      page: 1,
      pageSize: 20,
      total:0
    }
  },
  methods: {
    
    // 获取列表的数据
    initData(){
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      ProfitSharingOrderList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },

  },
  created() {
    this.initData();
  }
};
</script>
<style scoped lang="less">
  /* 表格单元格容器：flex布局，让文字占满空间，图标固定 */
  .ip-cell-container {
    display: flex;
    align-items: center;  /* 文字和图标垂直居中 */
    width: 100%;  /* 占满表格单元格宽度 */
  }

  /* IP文字区域：超出隐藏+省略号 */
  .ip-text {
    flex: 1;  /* 占满容器剩余空间（图标外的所有宽度） */
    overflow: hidden;  /* 超出隐藏 */
    text-overflow: ellipsis;  /* 超出显示省略号 */
    white-space: nowrap;  /* 强制不换行 */
    margin-right: 4px;  /* 文字和图标之间留一点间距，避免贴太紧 */
  }
  .table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }

</style>


